import { serverOrClient } from './server-or-client';
export const udVisiting = () => {
  var _serverOrClient$globa;
  return (_serverOrClient$globa = serverOrClient.global.UD) === null || _serverOrClient$globa === void 0 ? void 0 : _serverOrClient$globa.visiting;
};
//# sourceMappingURL=ud-visiting.js.map